import {EditorProps} from "react-data-grid";
import EditorComboboxBase from './base';
import React from "react";


const EditorCombobox = (props:EditorProps<any>) => {
    return <EditorComboboxBase {...props} />
}

export default EditorCombobox